/** google pay, apple pay, Pi錢包, 八達通 目前 web 沒有實作 */
export enum PaymentGateways {
  TapPay_TWD = 'TapPay_TWD',
  LINEPay_TWD = 'LINEPay_TapPay_TWD',
  MOLPay_TapPay_MYR = 'MOLPay_TapPay_MYR',
  GrabPay_MYR = 'GrabPay_MYR',
  ATM_TWD = 'ATM_To_Merchant_TWD',
  IPay88_MYR = 'IPay88_MYR',
  StripeHK_HKD = 'StripeHK_HKD',
  StripeJP_JPY = 'StripeJP_JPY',
  StripeTH_THB = 'StripeTH_THB', // Stripe (信用卡) (泰銖收款)
  StripeMY_MYR = 'StripeMY_MYR', // Stripe (信用卡) (馬幣收款)
  // 以下沒實作
  ApplePay_TWD = 'ApplePay_TapPay_TWD',
  GooglePay_TWD = 'GooglePay_TapPay_TWD',
  ApplePay_StripeHK_HKD = 'ApplePay_StripeHK_HKD',
  ApplePay_StripeJP_JPY = 'ApplePay_StripeJP_JPY',
  GooglePay_StripeHK_HKD = 'GooglePay_StripeHK_HKD',
  GooglePay_StripeJP_JPY = 'GooglePay_StripeJP_JPY',
  PiWalletPay_TapPay_TWD = 'PiWalletPay_TapPay_TWD',
  Octopus_AsiaPay_HKD = 'Octopus_AsiaPay_HKD',
  ApplePay_StripeTH_THB = 'ApplePay_StripeTH_THB', // Stripe (ApplePay) (泰銖收款)
  ApplePay_StripeMY_MYR = 'ApplePay_StripeMY_MYR', // Stripe (ApplePay) (馬幣收款)
  GooglePay_StripeTH_THB = 'GooglePay_StripeTH_THB', // Stripe (GooglePay) (以泰銖收款)
  GooglePay_StripeMY_MYR = 'GooglePay_StripeMY_MYR', // Stripe (GooglePay) (以馬幣收款)
}

/** 信用卡驗證狀態 */
export enum CreditCardVerifiedStatus {
  /** 未驗證 */
  Unverified = 0,
  /** 已驗證 */
  Verified = 1,
}

export const PaymentCreditCards = Object.freeze([
  PaymentGateways.TapPay_TWD,
  PaymentGateways.MOLPay_TapPay_MYR,
  PaymentGateways.StripeHK_HKD,
  PaymentGateways.StripeJP_JPY,
  PaymentGateways.StripeTH_THB,
  PaymentGateways.StripeMY_MYR,
])

export const PaymentMethodValue = Object.freeze({
  GrabPay: 'GrabPay',
  LinePay: 'LinePay',
  ATM: 'ATM',
  TapPay: 'TapPay',
})

export enum PaymentFromList {
  Michelin = 'michelin',
  Cathay = 'cathay',
  BookingEngine = 'booking_engine',
  FunBookV2 = 'FunBook',
}

export enum PaymentGatewayValues {
  SavedCard = 'savedCard',
  NewCard = 'newCard',
  LinePay = 'linePay',
  GrabPay = 'grabPay',
  ATM = 'atm',
}

export const PaymentGatewayType = Object.freeze({
  TapPay: 0,
  Stripe: 1,
})

export const PaymentReturnKeys = Object.freeze({
  /** 3D 驗證時間用 */
  ThreeDVerify: '3DVerify',
  /** 金流導頁面回來相關的資料用 */
  PaymentReturn: 'PaymentReturn',
  OrderDetailID: 'ORDER_DETAIL_ID',
  RedirectTo: 'RedirectTo',
  BookingPath: 'BookingPath',
})

export enum FunBookPromoType {
  Deny,
  Allow,
}

export enum PromoCodeStatus {
  NOT_APPLICABLE,
  ACTIVE,
  FULLY_USED,
}
export interface PromoProductPromoInfo {
  code?: number
  condition?: string
  currency_id?: number
  discount?: number
  end_at?: string
  id?: number
  promo_code_list_id?: number
  promo_title?: string
  status?: PromoCodeStatus
  symbol_code?: string
  usable?: boolean
  usage_rate?: string
  is_credit_limit?: boolean
  code_id?: number
  endat?: string
  without_bonus?: WithoutBonus
}

export interface WithoutBonus {
  discount: number
}

export enum PayType {
  /** 0: PromptPay */
  PromptPay,
}

export interface PromptPayPaymentInfo {
  pay_type: PaymentMethodsType.PromptPay
  info: {
    publishable_key: string
    client_secret: string
    email: string
  }
}

export enum PromptPayPaymentStatus {
  /** 行為未知 */
  Canceled = 'canceled',
  /** 行為未知 */
  Processing = 'processing',
  /** 按 X 純粹關閉 QRCode Modal 視窗 */
  QRCodeModalClosed = 'requires_action',
  /** 行為未知 */
  requires_capture = 'requires_capture',
  /** 行為未知 */
  requires_confirmation = 'requires_confirmation',
  /** 付款過期 */
  Expired = 'requires_payment_method',
  /** 付款成功 */
  Succeeded = 'succeeded',
}

export enum PromptPayPaymentStatusValue {
  Succeeded,
  ModalClosed,
  Error,
  Expired,
}

export const PromptPayPaymentStatusMap: Record<string, PromptPayPaymentStatusValue> = {
  [PromptPayPaymentStatus.Succeeded]: PromptPayPaymentStatusValue.Succeeded,
  /** expired 視為錯誤 */
  [PromptPayPaymentStatus.Expired]: PromptPayPaymentStatusValue.Error,
  [PromptPayPaymentStatus.QRCodeModalClosed]: PromptPayPaymentStatusValue.ModalClosed,
}

/**
 * @description https://github.com/myfunnow/funnow-api-doc/blob/7349402f364c650e05580fc559a84d8c52dab07f/docs/payment/gateway.md
 */

export interface PaymentGatewayInfo {
  /** @deprecated 請使用 payment_methods. V1:(1 TapPay, 2 Stripe), V2: (0 TapPay, 1 Stripe) */
  gateway_type: number
  /** @deprecated 請使用 payment_methods.pub_key. Stripe 用的 publishable key */
  publishable_key: string
  /** @deprecated 請移除這個參數的後續實作. TapPay x GooglePay 用的 merchant ID，只會在有 GooglePay_TapPay_TWD 時出現 */
  google_pay_merchant_id: string
  /** @deprecated 請移除這個參數的後續實作. TapPay x ApplePay 用的 merchant ID，只會在有 ApplePay_TapPay_TWD 時出現 */
  apple_pay_merchant_id: string
  /** 是否開立發票 */
  issue_invoice: boolean
  /** funbook promo 開關 */
  fb_promo_code_type: FunBookPromoType
  /** @deprecated 請使用 payment_methods. 可用的付款方式，列表內容請查下方對照表 */
  methods: Array<PaymentGateways>
  /** 可用的付款方式列表 */
  payment_methods: PaymentMethods[]
}

export interface PaymentMethods {
  id: number
  currency: PaymentGatewayCurrency
  /** 收款方式名稱，會過翻譯 */
  name: string
  /** 收款類型 */
  type: PaymentMethodsType
  /** 收款渠道 */
  provider_type: PaymentMethodProviderType
  /** 此付款方式+渠道前端初始化 SDK 需要的 key, ex: Stripe 的 publishable_key, 空值時隱藏欄位 */
  pub_key: string
}

/** 收款類型 */
export enum PaymentMethodsType {
  SavedCreditCard = -1,
  NewCreditCard,
  /** @deprecated Web 尚未實作  */
  GooglePay,
  /** @deprecated Web 尚未實作  */
  ApplePay,
  LINEPay,
  /** @deprecated Web 尚未實作  */
  FPX,
  /** @deprecated Web 尚未實作  */
  PiWallet,
  /** @deprecated Web 尚未實作  */
  Octopus,
  GrabPay,
  ATMToMerchant,
  PromptPay,
  /** @deprecated TNG 不顯示 payment options */
  TNG,
  AFTEE = 12,
}

export const PaymentMethodTypeImplementation = [
  PaymentMethodsType.NewCreditCard,
  PaymentMethodsType.LINEPay,
  PaymentMethodsType.GrabPay,
  PaymentMethodsType.ATMToMerchant,
  PaymentMethodsType.PromptPay,
  PaymentMethodsType.AFTEE,
]

/** 收款渠道 */
export enum PaymentMethodProviderType {
  None,
  TapPay,
  Stripe,
  /** @deprecated Web 沒有實作 */
  iPay88,
  /** @deprecated Web 沒有實作 (八達通) */
  AsiaPay,
  GrabPay,
  /** @deprecated 不走這設定 */
  TNG,
}

export interface PaymentGatewayCurrency {
  /** 幣別 ID */
  id: number
  /** 幣別代碼 */
  code: string
  /** 幣別符號 */
  symbol: string
  /** 幣別名稱 */
  name: string
  /** 匯率 */
  rate: number
}

export enum PaymentCreditCardIssuer {
  /** 0: 其他 */
  Other,
  /** 1: VISA */
  VISA,
  /** 2: MasterCard */
  MasterCard,
  /** 3: JCB */
  JCB,
  /** 4: AMEX */
  AMEX,
}

export const CREDIT_CARD_BRAND_ICON: Record<number, string> = {
  [PaymentCreditCardIssuer.VISA]: 'VISA@2x.jpg',
  [PaymentCreditCardIssuer.MasterCard]: 'mastercard@2x.jpg',
  [PaymentCreditCardIssuer.JCB]: 'JCB@2x.jpg',
  [PaymentCreditCardIssuer.AMEX]: 'amex@2x.jpg',
}

export interface CommonPaymentPostParam {
  amount: number
  bonus: number
  cvv: string | null
  orderID: string
  productAmount: number
  promoCodeID: number | null
  promoUsage: number
  from?: PaymentFromList
}
export interface StripePromptPayResult {
  payment_url: string
  payload: {
    pay_type: PaymentMethodsType
    info: {
      publishable_key: string
      client_secret: string
      email: string
    }
  }
}

export const PAYMENT_METHOD_OPTION_STORAGE_KEY = 'payment-method-option'
export const SEND_NOTIFICATION_STORAGE_KEY = 'send-notification'
export type CommonPaymentInfo = PromptPayPaymentInfo

export type PaymentAmountResult = {
  used_fun_coin: number
  remaining_fun_coin: number
  fun_coin_discount: string
  promo_discount: string
  delivery_fee: string
  txn_amount: string
  currency_code: string
  currency_symbol: string
  /** @deprecated 幣別對應的金額 (舊欄位) */
  multi_txn_amount: {
    hkd_delivery_fee: string
    hkd_txn_amount: string
    hkd_txn_amount_1f: string
    jpy_delivery_fee: string
    jpy_txn_amount: string
    myr_delivery_fee: string
    myr_txn_amount: string
    thb_delivery_fee: string
    thb_txn_amount: string
    twd_delivery_fee: string
    twd_txn_amount: string
  }
  /**
   * 幣別對應的金額 (新欄位)
   * @ref https://zoeknow.atlassian.net/browse/ZOEKIT-10628
   */
  multi_currency_info: {
    txn_amount: Record<string, string>
    txn_amount_for_octopus: Record<string, string>
    delivery_fee: Record<string, string>
    delivery_free_amount: Record<string, string>
  }
}

export type CreditCard = {
  id: number
  type: number
  card_type: number
  currency: CreditCardCurrency
  last: string
  issuer: string
  usable: boolean
  /** 支付渠道類型 (0: TapPay, 1: Stripe) */
  gateway_type?: number
  /** 驗證狀態 (0: 未驗證, 1: 已驗證) */
  verified_status?: number
}

export type CreditCardCurrency = {
  id: number
  symbol: string
  code: string
  decimal_precision: number
}

export const DEFAULT_CREDIT_CARD: CreditCard = {
  id: 0,
  type: 0,
  card_type: 1,
  currency: {
    id: 0,
    symbol: '$',
    code: 'TWD',
    decimal_precision: 0,
  },
  last: '',
  issuer: '',
  usable: true,
}

export type payByTngPayload = {
  orderid: string
  bonus: string
  amount: number
  promo_usage: string
  code_id: string
}

export enum TPCardFunding {
  UNKNOWN = -1,
  /** 信用卡 (Credit Card) */
  CREDIT,
  /** 簽帳卡 (Debit Card) */
  DEBIT,
  /** 預付卡 (Prepaid Card) */
  PREPAID,
}

export enum TPCardType {
  UNKNOWN = -1,
  VISA = 1,
  MASTER_CARD = 2,
  JCB = 3,
  UNION_PAY = 4,
  AMEX = 5,
}

export enum StripeCardFunding {
  UNKNOWN = 'unknown',
  /** 信用卡 (Credit Card) */
  CREDIT = 'credit',
  /** 簽帳卡 (Debit Card) */
  DEBIT = 'debit',
  /** 預付卡 (Prepaid Card) */
  PREPAID = 'prepaid',
}

export interface TPCardResult {
  status: number
  msg: string
  card: {
    prime: string
    issuer: string
    lastfour: string
    bincode: string
    funding: TPCardFunding
    type: TPCardType
    level: string
    country: string
    countrycode: string
  }
  clientip: string
}
